const f = {
  color: {
    background: "#ffffffff",
    day: {
      background: "#ffffffff",
      text: "#405261ff",
      disabled: "#7e8e9eff",
      hover: {
        text: "#304ddbff"
      },
      current: {
        background: "#f1f3f5ff",
        text: "#314351ff"
      },
      selected: {
        background: "#304ddbff",
        text: "#ffffff"
      },
      range: {
        background: "#ebf5ffff",
        text: "#304ddbff"
      },
      anotherMonth: "#fff"
    },
    weekdays: {
      text: "#314351ff"
    },
    deepNavigatorButton: {
      background: "#ffffffff",
      text: "#131b24ff",
      border: "#ffffff00",
      hover: {
        background: "#ebf5ffff",
        text: "#304ddbff",
        border: "#ebf5ffff"
      }
    },
    sequentialNavButton: {
      background: "#ffffff00",
      text: "#405261ff",
      border: "#ffffff00",
      disabled: "#7e8e9eff",
      hover: {
        background: "#ebf5ffff",
        text: "#304ddbff",
        border: "#ebf5ffff"
      }
    },
    periodButton: {
      background: "#ffffffff",
      text: "#405261ff",
      border: "#ffffff00",
      current: {
        background: "#f1f3f5ff",
        text: "#314351ff"
      },
      selected: {
        background: "#304ddbff",
        text: "#ffffff",
        hover: {
          background: "#ebf5ffff",
          text: "#304ddbff",
          border: "#ebf5ffff"
        }
      },
      disabled: "#7e8e9eff"
    }
  }
};
export {
  f as datePicker
};
